import { Image, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { AiOutlineCloseCircle, AiOutlinePlus } from "react-icons/ai";
import { FiLoader } from "react-icons/fi";
import { IoIosChatbubbles } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { photoBaseURL } from "../../../service/api";
import { useGetState } from "../../../context/useGetState";
import { LoadingMessage } from "../../..";
import { useEffect, useRef, useState } from "react";
import { follow, unFollow } from "../discover/service";
import useSmallScreen from "../../../components/useSmallScreen";
import thelogo from "../../../assets/thelogo.png";

function SearchResultModal({
  searchText,
  setSearchText,
  searchResult,
  loading,
  setRefresh,
  isDivOpen,
  setIsDivOpen,
  isSearchModalOpen,
  // openModal
}) {
  const bgColor = useColorModeValue("#fff", "#000216");
  const textColor = useColorModeValue("#294566", "#fff");
  const navigate = useNavigate();
  const { state } = useGetState();
  
  
  const [, setBtnLoading] = useState(false);
  const [smallScreen] = useSmallScreen();
  const [following, setFollowing] = useState(undefined)

  const account_type = state?.userInfo?.account_type;

  const style = {
    // display: isSearchModalOpen === true ? "block" : "none",
    position: "fixed",
    right: smallScreen ? "0" : "120px",
    borderRadius: "20px",
    padding: "10px 15px 10px 25px",
    boxShadow: "2px 13px 15px #00000033",
    top: "60px",
    background: bgColor,
    color: textColor,
    height: "300px",
    width: "400px",
    fontWeight: "light",
  };

  const btnStyle = {
    cursor: "pointer",
    alignSelf: "flex-end",
    direction: "row",
    borderRadius: "5px",
    p: "3px 3px 3px 4px",
    fontSize: ".8em",
    alignItems: "center",
    maxW: "100px",
    w: "80px",
    size: "sm",
    bg: "#005FFF",
    color: "#fff",
  };

  const exitBtnStyle = {
    cursor: "pointer",
    alignSelf: "flex-end",
    direction: "row",
    borderRadius: "5px",
    p: "3px 3px 3px 4px",
    fontSize: ".8em",
    alignItems: "center",
    maxW: "100px",
    w: "80px",
    size: "sm",
    bg: "red",
    color: "#fff",
  };

  useEffect(() => {
    setIsDivOpen(true);
  }, [searchText]);

  const handleCloseDiv = () => {
    setIsDivOpen(false);
  };

  // if (searchResult?.length > 0) {
  //   setIsDivOpen(true);
  // }

  // const handleFollow = async (userId) => {
  //   LoadingMessage();

  //   setBtnLoading(true);
  //   const formData = new FormData();
  //   formData.append("user_id", userId);
  //   await follow(formData, account_type, setBtnLoading);
  //   setRefresh({});
  // };

  const handleFollow = async (data) => {
    const userId = data?.id
    console.log('clickUser: ', data?.following_status);
    LoadingMessage();

    setBtnLoading(true);
    const formData = new FormData();
    formData.append("user_id", parseFloat(userId));
    if (data?.following_status) {
      await unFollow(userId, setBtnLoading);
      setFollowing(false);
    } else {
      await follow(userId, setBtnLoading);
      setFollowing(true);
    }
    setRefresh({});
  };

  const gotoProfileOverviewUser = (data) => {
    setIsDivOpen(true)
    //console.log('yes: ', data);
    setRefresh({});
    navigate(`/view-profile/${data?.id}`);
  }

  const messageFriend = (userInfo) => {
    navigate("/messaging", {
      state: { privateChatRecipient: { user: userInfo } },
    });

    setSearchText("");
  };

  return (
    searchText?.length > 0 &&
    isDivOpen && (
      <Stack {...style}>
        <Stack
          className="scroll-container"
          spacing={"20px"}
          pr="10px"
          h="300px"
          justifyContent={
            searchResult?.length < 1 || loading ? "center" : "normal"
          }
        >
          {loading ? (
            <FiLoader style={{ alignSelf: "center" }} />
          ) : searchResult?.length < 1 ? (
            <Text alignSelf={"center"} justifySelf="center" fontSize=".8em">
              No result found
            </Text>
          ) : (
            searchResult?.map((data) => {
              return (
                <Stack direction={"row"} alignItems="center" cursor={"pointer"}>
                  <Stack
                    w="100%"
                    alignItems="center"
                    direction={"row"}

                    //onClick={() => gotoProfileOverviewUser(data)}
                    onMouseDown={()=>{
                    navigate(`/view-profile/${data?.id}`);
                    }}


                  >
                    <Stack
                      boxShadow={"2px 2px 5px #0000004d"}
                      borderRadius="50%"
                      
                    >
                      <Image
                        w="35px"
                        h="35px"
                        objectFit={"cover"}
                        borderRadius={"50%"}
                        name={data?.name}
                        fallbackSrc={thelogo}
                        src={data?.picture}
                      />
                    </Stack>
                    <Stack flex={"2"} spacing="1">
                      <Text fontWeight={"400"}>{data?.name}</Text>
                      <Text fontSize={".8em"}>{`@${data?.username}`}</Text>
                    </Stack>
                  </Stack>

                  <Stack>
                    {data?.follow_status === "1" ? (
                      <Stack {...btnStyle} onClick={() => messageFriend(data)}>
                        <IoIosChatbubbles />

                        <Text>Message</Text>
                      </Stack>
                    ) : (
                      <Stack {...btnStyle} onClick={() => handleFollow(data)}>
                        <AiOutlinePlus />

                        {/*Unfollow1, Follow1, Unfollow2, Follow2 {data?.following_status ? <Text>Unfollow</Text> : <Text>Follow</Text>} */}
                        {following !== undefined ? (
                          following ? (
                            <Text>Unfollow</Text>
                          ) : (
                            <Text>Follow</Text>
                          )
                        ) : data?.following_status ? (
                          <Text>Unfollow</Text>
                        ) : (
                          <Text>Follow</Text>
                        )}
                      </Stack>
                    )}
                  </Stack>
                </Stack>
              );
            })
          )}
        </Stack>

        <Stack
          {...exitBtnStyle}
          display={"none"}
          onClick={handleCloseDiv}
        >
          <AiOutlineCloseCircle />
          <Text>Close</Text>
        </Stack>
      </Stack>
    )
  );
}

export default SearchResultModal;
